export default {
    sumTypes: (state) => {
        return {
            sum: state.registers.workers.current.sum_type,
            sum1: state.registers.workers.current.sum1_type,
            sum2: state.registers.workers.current.sum2_type,
            sum3: state.registers.workers.current.sum3_type
        }
    },
    user: (state) => {
        return state.user;
    },
    notification: (state) => {
        return state.messages
    },
    orgs: (state) => {
        return state.registers.orgs
    },
    org: (state) => {
        if (typeof state.registers.orgs.current != 'undefined') {
            if (state.registers.orgs.current.length == 0) {
                // Подстановка данных организации по умолчанию
                return state.registers.orgs.default;

            } else {
                return state.registers.orgs.current;
            }

        } else {
            return {}
        }
    },
    workers: (state) => {
        return state.registers.workers
    },
    workersEnum: (state) => {
        let workersArr = [];
        workersArr.push({text: 'Все сотрудники', value: 0});
        state.registers.workers.list.forEach(function (item){
            if (item.deleted == 0) {
                workersArr.push({text: item.last_name + ' ' + item.first_name + ' ' + item.middle_name, value: item.id});
            }
        });

        return workersArr

    },
    worker: (state) => {
        if (typeof state.registers.workers.current != 'undefined') {
            if (state.registers.workers.current.length == 0) {
                // Подстановка данных сотрудника по умолчанию
                return state.registers.workers.default;

            } else {
                return state.registers.workers.current;
            }
        } else {
            return {};
        }
    },
    groups: (state) => {
        return state.registers.groups
    },
    groupsEnum: (state) => {
        let groupsArr = [];
        groupsArr.push({text: 'Все подразделения', value: 0});
        state.registers.groups.list.forEach(function (item){
            groupsArr.push({text: item.name, value: item.id});
        });

        return groupsArr

    },
    salary: (state) => {
        return state.salary;
    },
    changed: (state) => {
        return state.changed;
    },
    changedRegister: (state) => {
        return state.changedRegister;
    },
    rating: (state) => {
        return state.rating;
    },
    form200: (state) => {
        return state.reports.form200
    },

    links: (state) => {
        return state.links;
    },

    vacationInit: state => () => {
        return state.defaults.vacation;
    },
    calcData: state => (params, period, org, worker, recoupment, indices, tax, calendar, vacation, zero_rate, other_income) => {
        state;
        return {
            indices: indices,
            tax: tax,
            calendar: calendar,
            params: params,
            org: org,
            period: period,
            worker: worker,
            recoupment: recoupment,
            vacation: vacation,
            zero_rate: zero_rate,
            other_income: other_income
        }
    },
    regSelect: state => (register, fields) => {
        var arr = {options: [], current: 0};
        if (typeof state.registers[register].list != 'undefined') {
            for (var i = 0; i < state.registers[register].list.length; i++) {
                if (!state.registers[register].list[i].deleted) {
                    var regname = Array();

                    for (var ii = 0; ii < fields.length; ii++) {
                        regname.push(state.registers[register].list[i][fields[ii]])
                    }

                    if (!state.registers[register].list[i].deleted) {
                        arr.options.push({value: state.registers[register].list[i].id, text: regname.join(' ')});
                    }

                }
            }
            arr.current = state.registers[register].current.id;
        }
        return arr;
    }
}
